import { render, staticRenderFns } from "./CustomInfiniteHits.vue?vue&type=template&id=42183bdc&"
import script from "./CustomInfiniteHits.vue?vue&type=script&lang=js&"
export * from "./CustomInfiniteHits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports